import { composeIO } from 'react-compose-io'
import { headerIO } from './Header.IO'
import { HeaderView } from './Header.View'

export const Header = composeIO(HeaderView, headerIO)
